import { CommonPage } from "@components/common";
import { Licenses } from "./Licenses";
export const LicensesPage = () => (
  <CommonPage title="Lizenzhinweise Dritter">
    <Licenses />
  </CommonPage>
);

